import NotificationThreshold from 'api/apiTypes/notification/threshold';

const ThresholdLabels: Record<Required<NotificationThreshold>['of'], string> = {
  pageview: 'Page Views',
  visitor: 'Visitors',
  session: 'Sessions',
} as const;

export default ThresholdLabels;
